import { ThemeUICSSObject, spacing } from '@apia/theme';
import animations from '../../../../global/animations';
/* IMPORT HERE */

const floating: ThemeUICSSObject = {
  bottom: '10px',
  maxWidth: 'floatingNotifications',
  position: 'fixed',
  right: '5px',
  width: '100%',
  zIndex: 'notifications',
  maxHeight: 'calc(100vh - 20px)',
  pr: '5px',

  '& > *:not(:last-child)': {
    mb: spacing(5),
  },

  '.notification.animate': {
    animation: `${animations.vibrate} 0.1s linear infinite`,
  },
  /* PREPEND HERE */
};

export default floating;
